// extracted by mini-css-extract-plugin
export default {"container":"MV8ZQD5h","modalOverlay":"vZhb65yf","modalWindow":"gooUYjlB","closeContainer":"nJRO9yxV","closeIcon":"cedJ9hgw"};